var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalSegment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83203 31.1666V9.91665C2.83203 9.54092 2.98129 9.18059 3.24696 8.91491C3.51264 8.64924 3.87297 8.49998 4.2487 8.49998H9.91537V2.83331H24.082V8.49998H29.7487C30.1244 8.49998 30.4848 8.64924 30.7504 8.91491C31.0161 9.18059 31.1654 9.54092 31.1654 9.91665V31.1666H19.832V24.0833H14.1654V31.1666H2.83203ZM12.7487 5.66665V14.1666H15.582V11.3333H18.4154V14.1666H21.2487V5.66665H18.4154V8.49998H15.582V5.66665H12.7487ZM5.66536 28.3333H11.332V24.0833H5.66536V28.3333ZM5.66536 21.25H11.332V17H5.66536V21.25ZM22.6654 28.3333H28.332V24.0833H22.6654V28.3333ZM22.6654 21.25H28.332V17H22.6654V21.25ZM14.1654 21.25H19.832V17H14.1654V21.25Z",
    fill: "#D2232A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalSegment);
export default __webpack_public_path__ + "static/media/hospital-segment.722850b3d8b807947830db691d432491.svg";
export { ForwardRef as ReactComponent };